// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Dialog-Content-module--cls1--2QkE_","cls2":"Dialog-Content-module--cls2--1DwX_ Dialog-Content-module--cls1--2QkE_"};